/* Site-Specific JavaScript */

(function () {
    var header = document.getElementById('site-header');
    if (!header || !document.body.classList.contains('page-type-ir-overview')) {
        return;
    }
    var update = function () {
        header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
})();

(function () {
    var links = document.querySelectorAll('#skipLinks a[href^="#"]');
    Array.prototype.forEach.call(links, function (link) {
        link.addEventListener('click', function (event) {
            var target = document.getElementById(link.getAttribute('href').slice(1));
            if (!target) {
                return;
            }
            event.preventDefault();
            if (!target.hasAttribute('tabindex')) {
                target.setAttribute('tabindex', '-1');
            }
            target.focus();
            target.scrollIntoView();
        });
    });
})();
